import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/antd'
import './assets/scss/index.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'

import echarts from 'echarts'
import './assets/js/china'

// require('./assets/js/china.js')

Vue.prototype.$echarts = echarts

Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
